import { render, staticRenderFns } from "./local-district.vue?vue&type=template&id=feba58e2&scoped=true&lang=html&"
import script from "./local-district.vue?vue&type=script&lang=js&"
export * from "./local-district.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feba58e2",
  null
  
)

export default component.exports